<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_authorityservices/_update/updateServicesDetail.vue'
export default {
  components: {
    createContent
  }
}
</script>
